import React from 'react';
import s from './Tags.module.scss';
import { Tag, type ITag } from './Tag';
import { Theme } from '../../types';

interface TagsProps {
  tags: ITag[];
  theme: Theme;
  disabled?: boolean;
}

export const Tags = ({ tags, theme, disabled }: TagsProps) => {
  return (
    <div className={s.tags}>
      {tags.map((tag, index) => (
        <Tag
          text={tag.text}
          icon={tag.icon}
          iconPosition={tag.iconPosition}
          key={`${tag.text}-${index}`}
          theme={theme}
          disabled={disabled || tag.disabled}
          onClick={tag.onClick}
        />
      ))}
    </div>
  );
};
